import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import { isEmpty } from 'lodash'
import GifNavigation from '../gifs/navigation'
import Toggle from 'shared/components/toggle/toggle'
import ChannelListLiveHeader from 'shared/components/channel-live-logo/live-header'
import Breadcrumbs from 'shared/components/breadcrumbs/breadcrumbs'
import { removeWords } from 'shared/util/string'
import { UsernameBadge } from 'shared/components/users'
import css from './header.css'
const { string, bool, func, object } = PropTypes
const IMAGE_TYPES = ['gif', 'gifs', 'sticker', 'stickers']

const Header = ({
    title,
    searchQuery,
    hasDescription,
    autoPlay,
    hideAutoplay,
    onToggleAutoPlay,
    channel,
    showGridNavigation,
    isChild,
    isTagView,
}) => {
    const { display_name, url, user, description, root_channel, is_live, short_display_name } = channel
    const ancestors = channel.ancestors || []
    return (
        <div className={css.container}>
            <div className={css.header}>
                <Title
                    user={user}
                    breadcrumbs={ancestors}
                    displayName={display_name}
                    shortDisplayName={short_display_name}
                    title={title}
                    hasDescription={hasDescription}
                    searchQuery={searchQuery}
                    isTagView={isTagView}
                    url={url}
                    isChild={isChild}
                    isLive={is_live}
                />
                {!hideAutoplay ? (
                    <div className={css.alignRight}>
                        <span className={css.autoPlayText}>Auto Play</span>
                        <Toggle
                            isOn={autoPlay}
                            onElement={<i className="ss-play" />}
                            offElement={<i className="ss-pause" />}
                            toggle={onToggleAutoPlay}
                        />
                    </div>
                ) : null}
            </div>
            {isChild ? (
                <Description
                    description={description}
                    showGridNavigation={showGridNavigation}
                    root_channel={root_channel}
                    channel={channel}
                />
            ) : null}
        </div>
    )
}

const Title = ({
    user,
    breadcrumbs,
    displayName,
    title,
    hasDescription,
    searchQuery,
    isTagView,
    url,
    isChild,
    isLive,
    shortDisplayName,
}) => {
    let titleStyle = isChild || searchQuery ? css.title : css.mainTitle
    titleStyle = hasDescription ? css.titleWithDescription : titleStyle

    return (
        <div className={css.titleContainer}>
            {breadcrumbs.length || searchQuery ? (
                <div className={css.breadcrumbs}>
                    <Breadcrumbs
                        breadcrumbs={breadcrumbs}
                        url={url}
                        displayName={displayName}
                        shortDisplayName={shortDisplayName}
                    />
                </div>
            ) : null}
            {isLive ? <ChannelListLiveHeader isMobile={false} /> : null}
            {title ? (
                <div className={css.titleContainer}>
                    <h1 className={titleStyle}>
                        {searchQuery && isTagView ? <span>Trending</span> : null}
                        {searchQuery && isTagView ? (
                            <span className={css.query}> {removeWords(searchQuery, IMAGE_TYPES)} </span>
                        ) : null}
                        <span>{title}</span>
                        {searchQuery && !isTagView ? <span className={css.query}> {searchQuery} </span> : null}
                    </h1>
                    <UsernameBadge className={css.usernameBadge} user={user} />
                </div>
            ) : null}
        </div>
    )
}

const Description = ({ description, showGridNavigation, root_channel, channel }) => (
    <div className={css.descriptionContainer}>
        {description ? <p className={css.description}>{description}</p> : null}
        <div className={css.subheader}>
            {showGridNavigation ? (
                <div className={css.navigation}>
                    <GifNavigation channel={isEmpty(root_channel) ? channel : root_channel} />
                </div>
            ) : null}
        </div>
    </div>
)

Header.propTypes = {
    title: string,
    searchQuery: string,
    hasDescription: bool,
    autoPlay: bool,
    hideAutoplay: bool.isRequired,
    onToggleAutoPlay: func.isRequired,
    channel: object,
    showGridNavigation: bool,
    isChild: bool,
}

export default Header
